// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * The following are shared across all platforms and apps
 */
:host {
  display: block;
  max-width: 100%;
  overflow-x: hidden;
}

.post-card-slider {
  font-family: "OpenSans-Regular";
  color: var(--undp-jtf-text-color);
  background: linear-gradient(180deg, #f8fafc 0%, #ffffff 100%);
  padding: 60px 0;
  max-width: 100%;
  overflow-x: hidden;
  box-sizing: border-box;
}
.post-card-slider .w-100 {
  width: 100% !important;
}
.post-card-slider .word-wrap {
  word-break: break-word;
}
.post-card-slider .additional-report-header {
  padding: 0 50px 50px;
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.post-card-slider .additional-report-header .title {
  font: normal normal 700 28px/36px "OpenSans-Regular";
  color: var(--undp-jtf-primary-color);
  margin: 0;
  position: relative;
  padding-bottom: 12px;
}
.post-card-slider .additional-report-header .title::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 60px;
  height: 4px;
  background: linear-gradient(90deg, var(--undp-jtf-primary-color), var(--undp-jtf-btn-dark-color));
  border-radius: 2px;
}
.post-card-slider .additional-report-header .pager-buttons {
  display: flex;
  gap: 10px;
}
.post-card-slider .additional-report-header .pager-buttons i {
  background: #ffffff;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  text-align: center;
  vertical-align: middle;
  padding: 16px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 12px rgba(0, 55, 112, 0.15);
  border: 2px solid rgba(0, 55, 112, 0.1);
  color: var(--undp-jtf-primary-color);
}
.post-card-slider .additional-report-header .left, .post-card-slider .additional-report-header .right {
  display: inline-block;
  cursor: pointer;
}
.post-card-slider .additional-report-header .left i:hover, .post-card-slider .additional-report-header .right i:hover {
  background: var(--undp-jtf-primary-color);
  color: #ffffff;
  transform: scale(1.05);
  box-shadow: 0 4px 16px rgba(0, 55, 112, 0.25);
}
.post-card-slider .additional-report-header .left i {
  padding-left: 14px !important;
}
.post-card-slider .additional-report-header .right i {
  padding-left: 16px !important;
}
.post-card-slider .additional-report-header .left.disabled, .post-card-slider .additional-report-header .right.disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.post-card-slider .additional-report-header .left.disabled i:hover, .post-card-slider .additional-report-header .right.disabled i:hover {
  background: #ffffff;
  color: var(--undp-jtf-primary-color);
  transform: none;
  box-shadow: 0 2px 12px rgba(0, 55, 112, 0.15);
}
.post-card-slider .container {
  display: flex;
  position: relative;
  justify-content: center;
  overflow: hidden;
  width: 100%;
}
.post-card-slider .container .cards {
  width: 100%;
  overflow: hidden;
}
.post-card-slider .container .cards .overflow {
  position: relative;
  transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  margin-left: 30px;
  flex-direction: row;
  align-items: stretch;
  flex-wrap: nowrap;
  padding-bottom: 20px;
  will-change: transform;
}
.post-card-slider .container .cards .overflow .card {
  box-sizing: border-box;
  flex-shrink: 0;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 55, 112, 0.08);
  display: flex;
  flex-direction: column;
  margin-right: 28px;
  margin-bottom: 20px;
  margin-top: 10px;
  position: relative;
  color: var(--undp-jtf-text-color);
  border: 1px solid #e2e8f0;
  transition: all 0.3s ease;
  cursor: pointer;
  overflow: hidden;
}
.post-card-slider .container .cards .overflow .card::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
  background: var(--undp-jtf-primary-color);
  transform: scaleY(0);
  transition: transform 0.3s ease;
}
.post-card-slider .container .cards .overflow .card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0, 55, 112, 0.15);
  border-color: var(--undp-jtf-primary-color);
}
.post-card-slider .container .cards .overflow .card:hover::after {
  transform: scaleY(1);
}
.post-card-slider .container .cards .overflow .card:hover .post-title {
  color: var(--undp-jtf-primary-color);
}
.post-card-slider .container .cards .overflow .card:hover .arrow-opacity {
  opacity: 1;
  transform: translateX(4px);
}
.post-card-slider .container .cards .overflow .card .card-container {
  padding: 28px;
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
}
.post-card-slider .container .cards .overflow .card .card-container .flex-card-row-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
  min-width: 0;
  align-items: flex-start;
  margin-bottom: 16px;
}
.post-card-slider .container .cards .overflow .card .card-container .flex-card-row-wrapper .flex-card-row {
  display: flex;
  flex-grow: 1;
  flex: 1 1 auto;
  min-width: 0;
  max-width: 85%;
}
.post-card-slider .container .cards .overflow .card .card-container .flex-card-row-wrapper .flex-card-column-wrapper {
  min-width: 0;
  overflow: hidden;
}
.post-card-slider .container .cards .overflow .card .card-container .flex-card-row-wrapper .arrow-opacity {
  opacity: 0.25;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  color: var(--undp-jtf-primary-color);
  font-size: 18px;
  margin-top: 2px;
}
.post-card-slider .container .cards .overflow .card .card-container .post-title {
  font: normal normal 600 17px/24px "OpenSans-Regular";
  color: var(--undp-jtf-primary-color);
  margin-bottom: 12px;
  transition: color 0.3s ease;
  overflow-wrap: anywhere;
  word-break: break-word;
}
.post-card-slider .container .cards .overflow .card .card-container .flex-detail-card-info-row {
  display: inline-flex;
  gap: 6px;
  font: normal normal 600 10px/14px "OpenSans-Regular";
  padding: 4px 10px;
  background: #f1f5f9;
  border-radius: 6px;
  color: var(--undp-jtf-primary-color);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  width: -moz-fit-content;
  width: fit-content;
}
.post-card-slider .container .cards .overflow .card .card-container .flex-detail-card-info-row span {
  color: var(--undp-jtf-primary-color);
  font-weight: 700;
}
.post-card-slider .container .cards .overflow .card .card-container .flex-subtitle-wrapper {
  font: normal normal normal 13px/20px "OpenSans-Regular";
  padding-top: 20px;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 14px;
  width: 100%;
  min-width: 0;
  border-top: 1px solid rgba(0, 55, 112, 0.08);
}
.post-card-slider .container .cards .overflow .card .card-container .flex-subtitle-wrapper img {
  flex-shrink: 0;
  opacity: 0.5;
  width: 16px;
  height: 16px;
  filter: brightness(0) saturate(100%) invert(27%) sepia(51%) saturate(2878%) hue-rotate(195deg) brightness(94%) contrast(101%);
}
.post-card-slider .container .cards .overflow .card .card-container .flex-subtitle-wrapper .flex-subtitle {
  display: flex;
  gap: 8px;
  align-items: flex-start;
  min-width: 0;
  max-width: 100%;
  color: #64748b;
}
.post-card-slider .container .cards .overflow .card .card-container .flex-subtitle-wrapper .flex-subtitle .fontPrimaryRegular {
  line-height: 1.5;
  font-weight: 400;
  min-width: 0;
  overflow-wrap: anywhere;
  word-break: break-word;
}
.post-card-slider .container .cards .overflow .card .card-container .card-category {
  padding-top: 18px;
  border-top: 1px solid rgba(0, 55, 112, 0.08);
  margin-top: 18px;
}
.post-card-slider .container .cards .overflow .card .card-container .card-category .title {
  font: normal normal 600 10px/14px "OpenSans-Light";
  text-transform: uppercase;
  letter-spacing: 0.8px;
  color: var(--undp-jtf-primary-color);
}
.post-card-slider .container .cards .overflow .card .card-container .card-category .description {
  font: normal normal normal 13px/20px "OpenSans-Regular";
  padding-top: 6px;
  color: #475569;
  overflow-wrap: anywhere;
  word-break: break-word;
}`, "",{"version":3,"sources":["webpack://./libs/scss/_index.scss","webpack://./apps/hybrid-app/src/app/features/shared/post-viewers/post-card-slider/post-card-slider.component.scss","webpack://./apps/hybrid-app/src/scss/_variables.scss"],"names":[],"mappings":"AAAA;;EAAA;ACCA;EACE,cAAA;EACA,eAAA;EACA,kBAAA;AAGF;;AAAA;EACE,+BCHqB;EDIrB,iCAAA;EACA,6DAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;AAGF;AADE;EACE,sBAAA;AAGJ;AADE;EACE,sBAAA;AAGJ;AADE;EACE,oBAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AAGJ;AAFI;EACE,oDAAA;EACA,oCAAA;EACA,SAAA;EACA,kBAAA;EACA,oBAAA;AAIN;AAFM;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,iGAAA;EACA,kBAAA;AAIR;AADI;EACE,aAAA;EACA,SAAA;AAGN;AAFM;EACE,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,aAAA;EACA,iDAAA;EACA,6CAAA;EACA,uCAAA;EACA,oCAAA;AAIR;AADI;EACE,qBAAA;EACA,eAAA;AAGN;AADQ;EACE,yCAAA;EACA,cAAA;EACA,sBAAA;EACA,6CAAA;AAGV;AACI;EACE,6BAAA;AACN;AACI;EACE,6BAAA;AACN;AACI;EACE,YAAA;EACA,mBAAA;AACN;AAAM;EACE,mBAAA;EACA,oCAAA;EACA,eAAA;EACA,6CAAA;AAER;AAEE;EACE,aAAA;EACA,kBAAA;EACA,uBAAA;EACA,gBAAA;EACA,WAAA;AAAJ;AACI;EACE,WAAA;EACA,gBAAA;AACN;AAAM;EACE,kBAAA;EACA,uDAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,oBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;AAER;AADQ;EACE,sBAAA;EACA,cAAA;EACA,mBAAA;EACA,mBAAA;EACA,4CAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iCAAA;EACA,yBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;AAGV;AADU;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,YAAA;EACA,yCAAA;EACA,oBAAA;EACA,+BAAA;AAGZ;AAAU;EACE,2BAAA;EACA,6CAAA;EACA,2CAAA;AAEZ;AAAY;EACE,oBAAA;AAEd;AACY;EACE,oCAAA;AACd;AAEY;EACE,UAAA;EACA,0BAAA;AAAd;AAIU;EACE,aAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AAFZ;AAGY;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;AADd;AAEc;EACE,aAAA;EACA,YAAA;EACA,cAAA;EACA,YAAA;EACA,cAAA;AAAhB;AAEc;EACE,YAAA;EACA,gBAAA;AAAhB;AAEc;EACE,aAAA;EACA,iDAAA;EACA,oCAAA;EACA,eAAA;EACA,eAAA;AAAhB;AAGY;EACE,oDAAA;EACA,oCAAA;EACA,mBAAA;EACA,2BAAA;EACA,uBAAA;EACA,sBAAA;AADd;AAGY;EACE,oBAAA;EACA,QAAA;EACA,oDAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,oCAAA;EACA,yBAAA;EACA,qBAAA;EACA,uBAAA;EAAA,kBAAA;AADd;AAGc;EACE,oCAAA;EACA,gBAAA;AADhB;AAIY;EACE,uDAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,8BAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,4CAAA;AAFd;AAIc;EACE,cAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,6HAAA;AAFhB;AAIc;EACE,aAAA;EACA,QAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;AAFhB;AAIgB;EACE,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,uBAAA;EACA,sBAAA;AAFlB;AAMY;EACE,iBAAA;EACA,4CAAA;EACA,gBAAA;AAJd;AAKc;EACE,kDAAA;EACA,yBAAA;EACA,qBAAA;EACA,oCAAA;AAHhB;AAKc;EACE,uDAAA;EACA,gBAAA;EACA,cAAA;EACA,uBAAA;EACA,sBAAA;AAHhB","sourcesContent":["/**\n * The following are shared across all platforms and apps\n */\n\n// shared variables\n@import 'variables';\n\n// create/import other scss files or define as needed...\n","@import '../../../../../scss/variables';\n:host {\n  display: block;\n  max-width: 100%;\n  overflow-x: hidden;\n}\n\n.post-card-slider {\n  font-family: $primary-font-regular;\n  color: var(--undp-jtf-text-color);\n  background: linear-gradient(180deg, #f8fafc 0%, #ffffff 100%);\n  padding: 60px 0;\n  max-width: 100%;\n  overflow-x: hidden;\n  box-sizing: border-box;\n  \n  .w-100 {\n    width: 100% !important;\n  }\n  .word-wrap {\n    word-break: break-word;\n  }\n  .additional-report-header {\n    padding: 0 50px 50px;\n    display: flex;\n    flex-wrap: nowrap;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    .title {\n      font: normal normal 700 28px/36px $primary-font-regular;\n      color: var(--undp-jtf-primary-color);\n      margin: 0;\n      position: relative;\n      padding-bottom: 12px;\n      \n      &::after {\n        content: '';\n        position: absolute;\n        bottom: 0;\n        left: 0;\n        width: 60px;\n        height: 4px;\n        background: linear-gradient(90deg, var(--undp-jtf-primary-color), var(--undp-jtf-btn-dark-color));\n        border-radius: 2px;\n      }\n    }\n    .pager-buttons {\n      display: flex;\n      gap: 10px;\n      i {\n        background: #ffffff;\n        width: 48px;\n        height: 48px;\n        border-radius: 50%;\n        text-align: center;\n        vertical-align: middle;\n        padding: 16px;\n        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n        box-shadow: 0 2px 12px rgba(0, 55, 112, 0.15);\n        border: 2px solid rgba(0, 55, 112, 0.1);\n        color: var(--undp-jtf-primary-color);\n      }\n    }\n    .left, .right {\n      display: inline-block;\n      cursor: pointer;\n      i {\n        &:hover {\n          background: var(--undp-jtf-primary-color);\n          color: #ffffff;\n          transform: scale(1.05);\n          box-shadow: 0 4px 16px rgba(0, 55, 112, 0.25);\n        }\n      }\n    }\n    .left i {\n      padding-left: 14px !important;\n    }\n    .right i {\n      padding-left: 16px !important;\n    }\n    .left.disabled, .right.disabled {\n      opacity: 0.4;\n      cursor: not-allowed;\n      i:hover {\n        background: #ffffff;\n        color: var(--undp-jtf-primary-color);\n        transform: none;\n        box-shadow: 0 2px 12px rgba(0, 55, 112, 0.15);\n      }\n    }\n  }\n  .container {\n    display: flex;\n    position: relative;\n    justify-content: center;\n    overflow: hidden;\n    width: 100%;\n    .cards {\n      width: 100%;\n      overflow: hidden;\n      .overflow {\n        position: relative;\n        transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);\n        display: flex;\n        margin-left: 30px;\n        flex-direction: row;\n        align-items: stretch;\n        flex-wrap: nowrap;\n        padding-bottom: 20px;\n        will-change: transform;\n        .card {\n          box-sizing: border-box;\n          flex-shrink: 0;\n          background: #ffffff;\n          border-radius: 12px;\n          box-shadow: 0 2px 8px rgba(0, 55, 112, 0.08);\n          display: flex;\n          flex-direction: column;\n          margin-right: 28px;\n          margin-bottom: 20px;\n          margin-top: 10px;\n          position: relative;\n          color: var(--undp-jtf-text-color);\n          border: 1px solid #e2e8f0;\n          transition: all 0.3s ease;\n          cursor: pointer;\n          overflow: hidden;\n          \n          &::after {\n            content: '';\n            position: absolute;\n            top: 0;\n            left: 0;\n            width: 4px;\n            height: 100%;\n            background: var(--undp-jtf-primary-color);\n            transform: scaleY(0);\n            transition: transform 0.3s ease;\n          }\n          \n          &:hover {\n            transform: translateY(-4px);\n            box-shadow: 0 8px 24px rgba(0, 55, 112, 0.15);\n            border-color: var(--undp-jtf-primary-color);\n            \n            &::after {\n              transform: scaleY(1);\n            }\n            \n            .post-title {\n              color: var(--undp-jtf-primary-color);\n            }\n            \n            .arrow-opacity {\n              opacity: 1;\n              transform: translateX(4px);\n            }\n          }\n          \n          .card-container {\n            padding: 28px;\n            min-width: 0;\n            max-width: 100%;\n            overflow: hidden;\n            .flex-card-row-wrapper {\n              display: flex;\n              flex-direction: row;\n              justify-content: space-between;\n              gap: 16px;\n              width: 100%;\n              min-width: 0;\n              align-items: flex-start;\n              margin-bottom: 16px;\n              .flex-card-row {\n                display: flex;\n                flex-grow: 1;\n                flex: 1 1 auto;\n                min-width: 0;\n                max-width: 85%;\n              }\n              .flex-card-column-wrapper {\n                min-width: 0;\n                overflow: hidden;\n              }\n              .arrow-opacity {\n                opacity: 0.25;\n                transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n                color: var(--undp-jtf-primary-color);\n                font-size: 18px;\n                margin-top: 2px;\n              }\n            }\n            .post-title {\n              font: normal normal 600 17px/24px $primary-font-regular;\n              color: var(--undp-jtf-primary-color);\n              margin-bottom: 12px;\n              transition: color 0.3s ease;\n              overflow-wrap: anywhere;\n              word-break: break-word;\n            }\n            .flex-detail-card-info-row {\n              display: inline-flex;\n              gap: 6px;\n              font: normal normal 600 10px/14px $primary-font-regular;\n              padding: 4px 10px;\n              background: #f1f5f9;\n              border-radius: 6px;\n              color: var(--undp-jtf-primary-color);\n              text-transform: uppercase;\n              letter-spacing: 0.5px;\n              width: fit-content;\n              \n              span {\n                color: var(--undp-jtf-primary-color);\n                font-weight: 700;\n              }\n            }\n            .flex-subtitle-wrapper {\n              font: normal normal normal 13px/20px $primary-font-regular;\n              padding-top: 20px;\n              display: flex;\n              flex-direction: column;\n              flex-wrap: wrap;\n              justify-content: space-between;\n              gap: 14px;\n              width: 100%;\n              min-width: 0;\n              border-top: 1px solid rgba(0, 55, 112, 0.08);\n              \n              img {\n                flex-shrink: 0;\n                opacity: 0.5;\n                width: 16px;\n                height: 16px;\n                filter: brightness(0) saturate(100%) invert(27%) sepia(51%) saturate(2878%) hue-rotate(195deg) brightness(94%) contrast(101%);\n              }\n              .flex-subtitle {\n                display: flex;\n                gap: 8px;\n                align-items: flex-start;\n                min-width: 0;\n                max-width: 100%;\n                color: #64748b;\n                \n                .fontPrimaryRegular {\n                  line-height: 1.5;\n                  font-weight: 400;\n                  min-width: 0;\n                  overflow-wrap: anywhere;\n                  word-break: break-word;\n                }\n              }\n            }\n            .card-category {\n              padding-top: 18px;\n              border-top: 1px solid rgba(0, 55, 112, 0.08);\n              margin-top: 18px;\n              .title {\n                font: normal normal 600 10px/14px $primary-font-medium;\n                text-transform: uppercase;\n                letter-spacing: 0.8px;\n                color: var(--undp-jtf-primary-color);\n              }\n              .description {\n                font: normal normal normal 13px/20px $primary-font-regular;\n                padding-top: 6px;\n                color: #475569;\n                overflow-wrap: anywhere;\n                word-break: break-word;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n","@import '@eview/scss/index';\n\n$primary-font: \"Montserrat\";\n$primary-font-bold: \"OpenSans-Bold\";\n$primary-font-medium: \"OpenSans-Light\";\n$primary-font-regular: \"OpenSans-Regular\";\n$primary-font-light: \"OpenSans-Light\";\n$primary-font-thin: \"OpenSans-Thin\";\n$secondary-font : \"Lato\";\n$secondary-font-bold: \"OpenSans-Bold\";\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
